module.exports = __webpack_public_path__ + "static/media/write-offSuc.6e0e6f25.png";